import { Injectable } from "@angular/core";
import { BodyForPricing, IPricingResponse } from "src/app/services/price-calculator.service";
import {Currency} from "../currencyService";
import {ModularConfig} from "../../factories/modular-configuration-factory";
import { IPriceApiResponse } from "src/app/factories/price-factory";
import { environment } from "src/environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, of } from "rxjs";

export interface IPimApiClient {
  calculatePrice(pimTenantId: string, contexts: [string], region: string, currency: Currency, configuration: ModularConfig, productSystemVersion: string): Observable<IPricingResponse>
}
@Injectable({
  providedIn: "root",
})
export class PimApiClient implements IPimApiClient {

  constructor(
    private httpClient: HttpClient,
  ) {}

  private getPrice(domain: string, httpBody: BodyForPricing): Observable<IPricingResponse> {
    let httpHeaders = new HttpHeaders();
    httpHeaders = httpHeaders.set("Content-Type", "application/json");
    httpHeaders = httpHeaders.set("Accept", "application/json");
    return this.httpClient.post<IPricingResponse>(domain, httpBody, {headers: httpHeaders});
  }

  public calculatePrice(pimTenantId: string, contexts: [string], region: string, currency: Currency, configuration: ModularConfig, productSystemVersion: string): Observable<IPricingResponse> {

    const url: string = `${environment.db3dBackendDomain}/api/price-proxy/`;

    const body: BodyForPricing = {
      contexts: contexts,
      region: region,
      brand: pimTenantId,
      currency: currency,
      configuration: configuration,
      version: productSystemVersion
    };

    return this.getPrice(url, body);
  }
}

export class PimApiClientMock implements IPimApiClient {
  public calculatePrice(_pimTenantId: string, _contexts: [string], _region: string, _currency: Currency, _configuration: ModularConfig): Observable<IPricingResponse> {
    const response: IPriceApiResponse = {
      "price": {
        "currency": "USD",
        "value": 1000
      },
    };
    return of(response);
  }
}